<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>


<style scoped>


</style>

<script setup>
import { useVisibilityState } from '@/composables/useVisibilityState'
import { useRealtimeListeners } from '@/composables/useRealtimeListeners'
const route = useRoute()
const authChecked = useAuthChecked()
const supabaseUserData = useSupabaseUserData()
const appVersionStatus = useAppVersionStatus()
const isMobile = useIsMobile()
const { subscribeToUserProfile, resubscribeAllChannels } = useRealtimeListeners()

const appVersionWarnModal = ref({
  show: false,
  title: 'New version available',
  message: `We've updated the app, please refresh to get the latest version to avoid any issues.`,
  confirmLabel: 'Reload',
  ignoreLabel: 'Ignore',
  confirmAction: reloadPage,
  data: null
})

watch(appVersionStatus, (newValue) => {
  console.log('appVersionStatus changed:', newValue);
  if (appVersionStatus.value === 'warnUser') {
    appVersionWarnModal.value.show = true;
  }
});

async function reloadPage () {
  window.location.reload()
}

// remove the listener when component is destroyed
onBeforeUnmount(() => {
  window.removeEventListener('resize', () => {
    isMobile.value = window.innerWidth > 768 ? false : true;
  });
})

onMounted(async()=>{
  console.log("App mounted")
  
  
  // check if we have a login link expired error
  if(route.hash && route.hash.includes('error=unauthorized_client')) {
    console.log('route.hash:', route.hash);
    // send to auth page but carry through the route params on this page
    // using navigateTo, we'll send the user to /auth with the query param of login_link_expired=1 along with any other query params in the url

    let newQuery = Object.assign({}, route.query)
    newQuery.login_link_expired = 1

    await navigateTo({ 
      path: '/auth',
      query: newQuery 
    })
  }

  initApp()

  isMobile.value = window.innerWidth > 768 ? false : true;
  window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth > 768 ? false : true;
  });
})

async function initApp() {

  console.log("initApp")

  // get the session
  const { $supabase } = useNuxtApp()
  let sessionData = await $supabase.auth.getSession()
  let userData = useSupabaseUserData()

  console.log('sessionData:', sessionData);

  if (sessionData.data.session && !userData.value) {
    // we have a session but no user data, get it. 
    const supabaseUser = useSupabaseUser()
    supabaseUser.value = sessionData.data.session.user

    identifyUser(sessionData.data.session.user)

    await getUserData(sessionData.data.session.user.id)

    // subscribe to the user profile
    subscribeToUserProfile(sessionData.data.session.user.id)

  } else {
    console.log("no session, or there is and we have user data already")

  }

  authChecked.value = true

  // check the app version
  checkVersion()

  // Start listiening for auth state changes
  $supabase.auth.onAuthStateChange((event, session) => {
    console.log('auth state change:', event, session)
    if (event === 'SIGNED_IN') {
      // we have a new session, get the user data
      getUserData(session.user.id)

      // subscribe to the user profile
      subscribeToUserProfile(session.user.id)

      // toast.success('Welcome back')
    } else if (event === 'SIGNED_OUT') {
      // we've been signed out, clear the user data
      supabaseUserData.value = null

    } else if (event === 'TOKEN_REFRESHED') {
      // Token has been refreshed, resubscribe to realtime channels
      console.log('🔄 Token refreshed, resubscribing to realtime channels...')
      
      // Wait a moment for the token to be fully updated
      setTimeout(() => {
        resubscribeAllChannels()
      }, 500)
    }
  })

}

// Initialize the visibility state tracking
const { isVisible, wasLastVisible } = useVisibilityState()

</script>